/** Relative /api/oauth/… returnUrl from the login page. Reject open redirects. */
export function mcpOAuthReturnUrl() {
  if (typeof window === "undefined") return null;
  const v = new URLSearchParams(window.location.search).get("returnUrl");
  if (!v) return null;
  if (!v.startsWith("/api/oauth/")) return null;
  if (v.startsWith("//") || v.includes("://")) return null;
  return v;
}

/** Full-page continue into /api/oauth/authorize. Query token covers sessions with no cookie yet. */
export function continueMcpOAuth(authToken) {
  const ret = mcpOAuthReturnUrl();
  if (!ret) return false;
  if (authToken) {
    const sep = ret.includes("?") ? "&" : "?";
    window.location.assign(
      `${ret}${sep}token=${encodeURIComponent(authToken)}`,
    );
  } else {
    window.location.assign(ret);
  }
  return true;
}
